import axios from 'axios';
import qs from 'qs';

export const createResourceBlock = ({ apiToken, resourceId, startDate, startTime, endDate, endTime, reason }) => {
    const requestData = {
        startDate,
        startTime,
        endDate,
        endTime,
        reason,
    };

    return axios.post(`${process.env.ONSCHED_API_URL}/setup/v1/resources/${resourceId}/block`, requestData, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${apiToken}`,
        },
    });
};

export const getAPIToken = () => {
    const requestData = {
        grant_type: 'client_credentials',
        scope: 'OnSchedApi',
        client_id: process.env.ONSCHED_CLIENT_ID,
        client_secret: process.env.ONSCHED_CLIENT_SECRET_2,
    };

    return axios.post(`${process.env.ONSCHED_IDENTITY_URL}/connect/token`, qs.stringify(requestData), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: '*/*',
            'Cache-Control': 'no-cache',
            'cache-control': 'no-cache',
        },
    });
};

export const getAppointments = ({ apiToken, locationId, resourceId, serviceId, startDate, endDate }) =>
    axios.get(
        `${process.env.ONSCHED_API_URL}/consumer/v1/appointments?${qs.stringify({
            locationId,
            resourceId,
            serviceId,
            startDate,
            endDate,
        })}`,
        {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${apiToken}`,
            },
        }
    );

export const getAvailability = ({ apiToken, locationId, resourceId, serviceId, startDate, endDate, tzOffset = 0 }) =>
    axios.get(
        `${process.env.ONSCHED_API_URL}/consumer/v1/availability/${serviceId}/${startDate}/${endDate}?${qs.stringify({
            locationId,
            resourceId,
            fullServerBasedAvailability: true,
            tzOffset,
        })}`,
        {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${apiToken}`,
            },
        }
    );

export const getLocations = ({ apiToken, name }) => {
    const queryParams = name ? `?name=${name}` : '';

    return axios.get(`${process.env.ONSCHED_API_URL}/consumer/v1/locations${queryParams}`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${apiToken}`,
        },
    });
};

export const getResources = ({ apiToken, locationId, email }) =>
    axios.get(`${process.env.ONSCHED_API_URL}/consumer/v1/resources?${qs.stringify({ locationId, email })}`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${apiToken}`,
        },
    });

export const getServices = ({ apiToken }) =>
    axios.get(`${process.env.ONSCHED_API_URL}/consumer/v1/services`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${apiToken}`,
        },
    });

export const getUnavailability = ({ apiToken, locationId, resourceId, serviceId, startDate, endDate, tzOffset = 0 }) =>
    axios.get(
        `${
            process.env.ONSCHED_API_URL
        }/consumer/v1/availability/${serviceId}/${startDate}/${endDate}/unavailable?${qs.stringify({
            locationId,
            resourceId,
            fullServerBasedAvailability: true,
            tzOffset,
        })}`,
        {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${apiToken}`,
            },
        }
    );

export const deleteResourceBlock = ({ apiToken, blockId }) =>
    axios.delete(`${process.env.ONSCHED_API_URL}/setup/v1/resources/block/${blockId}`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${apiToken}`,
        },
    });
